/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-1",
    "aws_appsync_graphqlEndpoint": "https://wbipzs2xsngvrd4keh6yayhslu.appsync-api.us-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-xmybalobf5h3dalxlb3yoqpcya",
    "aws_cognito_identity_pool_id": "us-west-1:ee9cc747-b7ff-4950-81fc-4fd5535784f8",
    "aws_cognito_region": "us-west-1",
    "aws_user_pools_id": "us-west-1_BmRnfQvhm",
    "aws_user_pools_web_client_id": "4ro9jqhtsjgjb3r1sbe066r3eh",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
